export const STRING_TYPE = 'string'
